<!-- SECTION PAGE 8 Start-->
<!-- <section class="container-fluid ms-main-bg py-5"> -->
    <div class="container ms-pg-structure my-5">

        <div class="d-flex-between-mob-column">
            <div>
                <h4 class="large-h main-heading">{{"Visit Calander" | translator}}</h4>
            </div>
        </div>

        <div class="white-box">
            <div class="d-flex justify-content-center">
              <div class="max-width-1400">
                <div class="d-flex justify-content-between align-items-center">
                  <button class="ms-btn-onclick my-2" (click)="prevMonth()"><b>{{'Previous Month' | translator}}</b></button>
                  <h2 class="my-2 t-main-b">{{ formatMonth() | translator}} {{formatYear()}}</h2>
                  <button class="ms-btn-onclick my-2" (click)="nextMonth()"><b>{{'Next Month' | translator }}</b></button>
                </div>
                <div class="d-flex justify-content-start flex-wrap">
                  <div class="calender-day-box" *ngFor="let day of daysOfWeek">{{ day | translator }}</div>
                </div>
                <div class="d-flex justify-content-start flex-wrap my-3">
                  <!-- <ng-container *ngFor="let dayData of calendarData" > -->
                    <div *ngFor="let week of calendarData"  class="d-flex justify-content-start flex-wrap">
                        <div *ngFor="let dayData of week" [ngClass]="{'negative-day': dayData._id.day <= 0}" (click)="getModalData(dayData);" class="calender-number-box">
                          <div class="calender-postition-number" [hidden]="dayData._id.day<=0" >{{ dayData._id.day }}</div>
                          <div class="ms-flex-column">
                          <div class="calender-training-topic" *ngFor="let training of dayData.data">
                            {{ userProfileFlag ? training.title : training.trainingDetails.title ? training.trainingDetails.title : training.topic}}
                          </div>
                        </div>
                        </div>
                      </div>
                  <!-- </ng-container> -->
                </div>
              </div>
            </div>
          </div>

       

    </div>


    <p-dialog header="{{'Training Calender' | translator}}" [(visible)]="showDilogue" [modal]="true" [style]="{ width: '90vw' , maxWidth:'1000px' }" [draggable]="false" [resizable]="false">
      <div class="container-fluid ms-bg-modal 222">
      <div class="d-flex w-100" *ngFor="let data of modalData?.data;let i = index" (click)="showTrainingDetail(data)">
            <p class="train-ms-grey-inner-box-numm">{{i+1}}</p>
            <div class="d-flex w-100">
              <ng-container *ngIf="userProfileFlag">
                <div class="train-ms-grey-inner-box">{{data?.title}}</div>
                <!-- <div class="train-ms-grey-inner-box">{{data?.ou?.name}}</div> -->
                <div [ngClass]="data.request_id.status" class="train-ms-grey-inner-box w-25-imp">{{data.request_id.status | translator}}</div>
              </ng-container>
              <ng-container *ngIf="!userProfileFlag">
                <div class="train-ms-grey-inner-box"> {{ data.trainingDetails.title ? data.trainingDetails.title : data.topic }}</div>
                <div class="train-ms-grey-inner-box">{{data?.ou?.name}}</div>
                <div [ngClass]="data.status" class="train-ms-grey-inner-box w-25-imp">{{data.status | translator}}</div>
              </ng-container>
          </div>
        </div>
      </div>
    </p-dialog>
<!-- </section>  -->
<!-- SECTION PAGE 8 End -->